/* artvision® · Collectors Club · Mitgliedskarte
   Lässt den Glanz der Karten (snippets/av-cc-member-card.liquid) beim
   Scrollen über das Metall wandern — wie im Collector Account. Höchstens
   einmal pro Frame; bei „Bewegung reduzieren“ steht der Glanz in der Mitte. */
(() => {
  const CARD_SELECTOR = '[data-av-cc-card]';
  const POSITION_PROPERTY = '--av-cc-card-shine-position';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  /** 0 when the card enters the viewport at the bottom, 1 when it left at the top. */
  function shineProgress(cardTop, cardHeight, viewportHeight) {
    const progress = (viewportHeight - cardTop) / (viewportHeight + cardHeight);
    return Math.max(0, Math.min(1, progress));
  }

  function start() {
    const cards = Array.from(document.querySelectorAll(CARD_SELECTOR));
    if (cards.length === 0) return;

    const motion = window.matchMedia(REDUCED_MOTION_QUERY);
    let frame = null;

    const update = () => {
      frame = null;
      cards.forEach((card) => {
        if (motion.matches) {
          card.style.removeProperty(POSITION_PROPERTY);
          return;
        }
        const bounds = card.getBoundingClientRect();
        card.style.setProperty(POSITION_PROPERTY, `${shineProgress(bounds.top, bounds.height, window.innerHeight) * 100}%`);
      });
    };
    const schedule = () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    motion.addEventListener('change', schedule);
    update();
  }

  window.avCcMemberCard = { shineProgress };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
